<div class="pagina-inactiva">
  <img src="../../../assets/IOlogo_linear2-1.png" class="imgLogo" alt="IO_Logo" />
  <h2>Attention!</h2>
  <p>You have been inactive for a while. The session has ended.</p>
  <button (click)="fnReloadPage()">Continue Session</button>
</div>
